import React from 'react'
import DataView from 'EurestoComponents/DataForm'
import Constants from 'EurestoFonction/Constants'


export const Rubrique = () => (
    <DataView module={Constants.module.GESTION} object={Constants.donnee.rubrique}/>
)

export default Rubrique



// WEBPACK FOOTER //
// ./app/App/Module/Configuration/Component/Gestion/Rubrique/index.js